<!-- prettier-ignore -->
<template>
  <aw-dropdown class="dropdown" placement="bottom-start" @show="onDropdownShow" @hide="onDropdownHide" v-model="opened">
    <template v-slot:btn="{ btn }">
      <slot name="btn" v-bind="{ openSelect, opened, closeSelect, searchInput, selectedOptions, multiple, searchInputElRef, removeOption, btn }">
        <div @click="openSelect" class="bg-white relative w-full text-left cursor-default dropdown-button" :ref="btn">
          <template v-if="!multiple">
            <input type="text" v-model="searchInput.value" :placeholder="searchInput.placeholder" class="p-0 border-none outline-none ring-0 block w-full text-sm placeholder-gray-700" :ref="searchInputElRef" @focus="openSelect">
            <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <!-- Heroicon name: selector -->
              <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </span>
          </template>
          <template v-else>
            <template v-for="option in selectedOptions" :key="option.id">
              <slot name="items" v-bind="{ option, removeOption }" />
            </template>
            <input type="text" v-model="searchInput.value" :placeholder="searchInput.placeholder" class="p-0 border-none inline-flex outline-none ring-0 text-sm placeholder-gray-700" :ref="searchInputElRef" @focus="openSelect">
          </template>
        </div>
      </slot>
    </template>
    
    <template v-slot:dropdown="{ opened, dropdown }">
      <ul 
        :ref="dropdownRef(dropdown)"
        tabindex="-1"
        role="listbox"
        :class="ulClass"
        v-show="opened"
      >
        <slot
          name="loading"
          v-if="loading && !showMaxItemsSelected"
        >
          <li>Loading</li>
        </slot>
        <slot
            name="noresults"
            v-bind="{ searchInput, closeSelect }"
            v-if="showNoResults && !loading && !showMaxItemsSelected"
        >
          <li class="dropdown-item">Žádný výsledek nenalezen, změnte hledaný výraz</li>
        </slot>
        <slot
            name="maxitems"
            v-bind="{ maxItems }"
            v-if="showMaxItemsSelected"
        >
          <li class="dropdown-item">Můžete vybrat maximálně {{ maxItems }} možností</li>
        </slot>
        <slot
            name="maxresults"
            v-bind="{ searchInput, maxOptions, filteredOptions, resultsCount, filteredAndLimitedOptions }"
            v-if="showMaxResultsExceeded && !loading && !showMaxItemsSelected"
        >
          <li class="dropdown-item">Zobrazeno prvních {{ filteredAndLimitedOptions.length }} záznamů z {{ resultsCount }}. Upřesněte hledaný výraz</li>
        </slot>
        <template v-if="opened">
          <template
            v-for="(option, optionIndex) in filteredAndLimitedOptions" 
            :key="option.id"
          >
            <slot
              name="option"
              v-bind="{ 
                option, handleMouseEnter, selectOption, interactedAddOption,
                highlighted: optionIndex === cursor, 
                selected: value.indexOf(option.id) !== -1,
                optionRef: optionIndex === cursor ? (el) => { this.selectedOptionRef(el); return; } : null
              }"
              v-if="!loading && !showMaxItemsSelected"
            >
              <li class="dropdown-item"
                :class="{ 'text-white bg-indigo-600': highlighted, 'text-gray-900': !highlighted }"
                @mouseenter="handleMouseEnter(option)"
                @click.stop="selectOption(option)"
                :ref="optionRef"
              >
                <span class="font-normal block" :class="{ 'font-semibold': selected, 'font-normal': !selected }">
                  <span v-if="option.newOption">přidat nový: </span>{{ option.label }}
                </span>
                <span class="absolute inset-y-0 left-0 flex items-center pl-1.5" :class="{ 'text-white': highlighted, 'text-indigo-600': !highlighted }" v-show="selected">
                  <!-- Heroicon name: check -->
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                  </svg>
                </span>
              </li>
            </slot>
          </template>
        </template>
      </ul>
    </template>
  </aw-dropdown>
</template>

<!-- prettier-ignore -->
<script>
import AwSelectMixin from '../mixins/awSelect'

export default {
  mixins: [AwSelectMixin],
  props: {
    ulClass: {
      type: String,
      default: 'dropdown-menu max-w-full'
    }
  },
  computed: {
    filteredOptions () {
      return this.multiple === false
        ? this.optionsStage3
        : this.optionsStage3.filter((option) => this.value.indexOf(option.id) === -1)
    },
  },
  methods: {
    onDropdownShow() {
      this.addKeyHandler()
      if (this.searchInputEl) {
        this.searchInputEl.focus()
      }

      this.updateCursorIndex(true)
    },
    onDropdownHide() {
      this.removeKeyHandler()
      this.searchInput.value = ''
      if (this.searchInputEl) {
        this.searchInputEl.blur()
      }

      this.cursor = null
    },
    dropdownRef(dropdown) {
      return (el) => {
        this.optionsContainerRef(el)
        dropdown(el)
      }
    },
  }
}
</script>
